import { render, staticRenderFns } from "./TodoChats.vue?vue&type=template&id=22f694ba&scoped=true"
import script from "./TodoChats.vue?vue&type=script&lang=js"
export * from "./TodoChats.vue?vue&type=script&lang=js"
import style0 from "./TodoChats.vue?vue&type=style&index=0&id=22f694ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f694ba",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QBtn,QOptionGroup,QIcon,QCard,QChatMessage,QSpace,QDialog,QCardSection,QCardActions});qInstall(component, 'directives', {ClosePopup});
